@if (isLoading$ | async) {
<section class="loading-logo">
  <div class="loader-content">

    <!-- Cyber-Tech HUD Container -->
    <div class="hud-wrapper">
      <!-- Concentric Rotating Tech Rings -->
      <div class="hud-ring ring-outer"></div>
      <div class="hud-ring ring-middle"></div>
      <div class="hud-ring ring-inner"></div>

      <!-- Premium Glassmorphic Logo Card -->
      <div class="logo-container">
        <img src="../assets/images/main/white 1.webp" loading="lazy" alt="app white logo">
        <div class="logo-shine"></div>
      </div>

      <!-- Soft Radial Light Backdrop -->
      <div class="glow-backdrop"></div>
    </div>

    <!-- Modern Linear Progress Bar -->
    <div class="progress-bar-container">
      <div class="progress-bar-fill"></div>
    </div>

    <!-- High-Tech Status Ticker (browser only: it was the first text Google saw on every page) -->
    @if (isBrowser) {
    <div class="status-ticker" aria-hidden="true" data-nosnippet>
      <div class="ticker-track">
        <div class="ticker-item">INITIALIZING PROTOCOLS...</div>
        <div class="ticker-item">SECURING CONNECTION...</div>
        <div class="ticker-item">LOADING PREMIUM DEALS...</div>
        <div class="ticker-item">PREPARING USER DASHBOARD...</div>
      </div>
    </div>
    }

    <!-- Floating Light Particles -->
    <div class="particles">
      <span class="particle p-1"></span>
      <span class="particle p-2"></span>
      <span class="particle p-3"></span>
      <span class="particle p-4"></span>
      <span class="particle p-5"></span>
    </div>
  </div>

  <!-- Drifting Ambient Background Glows -->
  <div class="circles">
    <span class="circle-1 position-absolute"></span>
    <span class="circle-2 position-absolute"></span>
  </div>
</section>
}


<div class="app" [ngClass]="[lightMood ? 'light-mood' : '', language$() ? language$() : 'en']">
  <router-outlet></router-outlet>
  <app-toast-container />
</div>
<mobile-toaster></mobile-toaster>